<template>
    <div class="routine-modal input-full-width">
        <div class="modal-header">
            <h2 v-if="!data" class="text-center">Rutine</h2>
        </div>

        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="routine small-svg" name="routine" />
                </div>
                <div class="small-3 cell flexbox align-items">
                    <label for="routineSelectDiv">Interval</label>
                </div>
                <div class="auto cell" id="routineSelectDiv">
                    <button class="flexbox-center" v-for="routine in routineIntervalTypeList" :key="routine.code" @click="selectIntervalType(routine)" style="cursor: pointer; height: 50px; margin-right: 20px;">
                        <div class="button-radio-round flexbox-center" :class="{'selected-item': createdRoutine.routineIntervalTypeId === routine.sysRoutineIntervalTypeId}">
                            <icon class="history small-svg fill-white" name="history" />
                        </div>
                        <span style="padding-top: 0px;" :class="{'disabled': createdRoutine.routineIntervalTypeId !== routine.sysRoutineIntervalTypeId}" >{{routine.description}}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="routine small-svg" name="repeat" />
                </div>
                 <div class="small-3 cell flexbox align-items">
                    <label for="routineRepeatDiv">Gentag</label>
                </div>
                <div class="auto cell" id="routineRepeatDiv">
                    <div class="grid-x time-group grid-x-full-width">
                        <button class="time-cell flexbox-center" v-for="unit in unitOfTimeTypeList" :key="unit.code" @click="changeRepeatTime(unit)" :class="{'selected-time': createdRoutine.routineUnitOfTimeTypeId === unit.sysUnitOfTimeTypeId}">
                            {{unit.description}}
                        </button>
                    </div>
                    <div class="grid-x grid-x-full-width">
                        <div class="flexbox-centertext time-group-interval">
                            <p>Hver<span v-if="humanRoutineUnitOfTimeType === 'År'">t</span> <span v-if="createdRoutine.routineInterval > 1">{{createdRoutine.routineInterval}}.</span> {{humanRoutineUnitOfTimeType | toLowerCase}}</p>
                        </div>
                        <div class="cell medium-8">
                            <div class="buttons grid-x">
                                <div class="cell medium-6 flexbox-center relative">
                                    <button @click="subtractNumber" type="button" class="absolute-full cursor flexbox-center plus-minus-button">
                                        <icon class="smaller-svg" name="minus" />
                                    </button>
                                </div>
                                <div class="cell medium-6 flexbox-center relative">
                                    <button @click="addNumber" type="button" class="absolute-full cursor flexbox-center plus-minus-button">
                                        <icon class="smaller-svg" name="plus" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="routine small-svg" name="deadline" />
                </div>
                 <div class="small-3 cell flexbox align-items">
                    <label for="routineRepeatDiv">Tid til udførelse</label>
                </div>
                <div class="auto cell" id="routineRepeatDiv">
                    <div class="grid-x time-group grid-x-full-width">
                        <button class="time-cell flexbox-center" v-for="unit in unitOfTimeTypeList" :key="unit.code" @click="changeDeadlineTime(unit)" :class="{'selected-time': createdRoutine.routineDeadlineUnitTypeId === unit.sysUnitOfTimeTypeId}">
                            {{unit.description }}
                        </button>
                    </div>
                    <div class="grid-x grid-x-full-width">
                        <div class="flexbox-centertext time-group-interval">
                            <p>
                                <span>{{createdRoutine.routineDeadlineInterval}}</span>
                                <span>{{humanRoutineDeadlineUnitType | toLowerCase}}<template v-if="createdRoutine.routineDeadlineInterval > 1"><span v-if="humanRoutineDeadlineUnitType === 'Dag'">e</span><span v-else-if="humanRoutineDeadlineUnitType === 'Uge'">r</span><span v-else-if="humanRoutineDeadlineUnitType === 'Måned'">er</span></template></span>
                            </p>
                        </div>
                        <div class="cell medium-8">
                            <div class="buttons grid-x">
                                <div class="cell medium-6 flexbox-center relative">
                                    <button @click="subtractDeadlineNumber" type="button" class="absolute-full cursor flexbox-center plus-minus-button">
                                        <icon class="smaller-svg" name="minus" />
                                    </button>
                                </div>
                                <div class="cell medium-6 flexbox-center relative">
                                    <button @click="addDeadlineNumber" type="button" class="absolute-full cursor flexbox-center plus-minus-button">
                                        <icon class="smaller-svg" name="plus" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="routine small-svg" name="flag" />
                </div>
                 <div class="small-3 cell flexbox align-items">
                    <label for="routineStartDiv">Aktiviteter oprettes i perioden</label>
                </div>

                <div class="small-8 cell">
                    <div style="align-items: center; display: flex; gap: 12px;">
                        <div class="calendar-input">
                            <base-date-picker id="task-routine-startDate" :max-date="createdRoutine.latestDate" v-model="createdRoutine.startDate">Startdato</base-date-picker>
                            <icon class="calendar small-svg" name="calendar" />
                        </div>
                        <strong>-</strong>
                        <div class="calendar-input">
                            <base-date-picker id="task-routine-latestDate" :min-date="createdRoutine.startDate" v-model="createdRoutine.latestDate">Slutdato</base-date-picker>
                            <icon class="calendar small-svg" name="calendar" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form">
            <div class="grid-x">
                <div class="small-1 cell flexbox-center">
                    <icon class="routine small-svg" name="calendar" />
                </div>
                 <div class="small-3 cell flexbox align-items">
                    <label for="routineStartDiv">Næste startdato</label>
                </div>
                <div class="small-8 cell">
                    <div style="align-items: center; display: flex; gap: 12px;">
                        <div class="calendar-input">
                            <base-date-picker id="task-routine-routineNextDate" v-model="createdRoutine.routineNextDate">Næste startdato</base-date-picker>
                            <icon class="calendar small-svg" name="calendar" />
                        </div>
                    </div>
                </div>
                <div class="cell small-1 text-center flexbox-center"></div>
                <div class="cell auto"></div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" v-if="!data" @click="save()">Opret</button>
                <button type="button" class="button-green" v-else @click="save()">Gem</button>
                <button type="button" class="button-naked" @click="closeModal()">Fortryd</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseDatePicker from '@/components/base/BaseDatePicker.vue'

export default {
    name: 'task-modal-routine',
    props: {
        data: Object
    },
    components: {
        BaseDatePicker
    },
    data () {
        return {
            humanRoutineUnitOfTimeType: null,
            humanRoutineDeadlineUnitType: null,
            createdRoutine: {
                routineIntervalTypeId: null,
                routineUnitOfTimeTypeId: null,
                routineInterval: null,
                routineDeadlineUnitTypeId: null,
                routineDeadlineInterval: null,

                startDate: null,
                latestDate: null,
                routineNextDate: null
            }
        }
    },
    computed: {
        ...mapGetters({
            unitOfTimeTypeList: 'getSysUnitOfTimeTypeList',
            routineIntervalTypeList: 'getSysRoutineIntervalTypeList',
            getSelectedActivities: 'getSelectedActivities'
        })
    },
    methods: {
        ...mapActions({
            updateActivity: 'updateActivity'
        }),

        selectIntervalType (routine) {
            this.createdRoutine.routineIntervalTypeId = routine.sysRoutineIntervalTypeId
        },
        closeModal () {
            this.$emit('close')
        },
        async save () {
            let routineObjects = []
            if (this.data) {
                this.data.routineIntervalTypeId = this.createdRoutine.routineIntervalTypeId ? this.createdRoutine.routineIntervalTypeId : null
                this.data.routineUnitOfTimeTypeId = this.createdRoutine.routineUnitOfTimeTypeId ? this.createdRoutine.routineUnitOfTimeTypeId : null
                this.data.routineInterval = this.createdRoutine.routineInterval ? this.createdRoutine.routineInterval : null
                this.data.routineDeadlineUnitTypeId = this.createdRoutine.routineDeadlineUnitTypeId ? this.createdRoutine.routineDeadlineUnitTypeId : null
                this.data.routineDeadlineInterval = this.createdRoutine.routineDeadlineInterval ? this.createdRoutine.routineDeadlineInterval : null

                this.data.startDate = this.createdRoutine.startDate ? this.createdRoutine.startDate : null
                this.data.latestDate = this.createdRoutine.latestDate ? this.createdRoutine.latestDate : null
                this.data.routineNextDate = this.createdRoutine.routineNextDate ? this.createdRoutine.routineNextDate : null

                this.updateActivity(this.data)
                    .then(() => {
                        this.$parent.$parent.$parent.savedTimestamp = new Date()
                        this.closeModal()
                    })
            } else {
                for (let i = 0; i < this.getSelectedActivities.length; i++) {
                    if (this.getSelectedActivities[i].selected && this.getSelectedActivities[i].allObjectsInActivityCount > 0 && !this.getSelectedActivities[i].routineIntervalTypeId) {
                        let selectedActivity = Object.assign({}, this.getSelectedActivities[i])

                        selectedActivity.routineIntervalTypeId = this.createdRoutine.routineIntervalTypeId ? this.createdRoutine.routineIntervalTypeId : null
                        selectedActivity.routineUnitOfTimeTypeId = this.createdRoutine.routineUnitOfTimeTypeId ? this.createdRoutine.routineUnitOfTimeTypeId : null
                        selectedActivity.routineInterval = this.createdRoutine.routineInterval ? this.createdRoutine.routineInterval : null
                        selectedActivity.routineDeadlineUnitTypeId = this.createdRoutine.routineDeadlineUnitTypeId ? this.createdRoutine.routineDeadlineUnitTypeId : null
                        selectedActivity.routineDeadlineInterval = this.createdRoutine.routineDeadlineInterval ? this.createdRoutine.routineDeadlineInterval : null

                        selectedActivity.startDate = this.createdRoutine.startDate ? this.createdRoutine.startDate : null
                        selectedActivity.latestDate = this.createdRoutine.latestDate ? this.createdRoutine.latestDate : null
                        selectedActivity.routineNextDate = this.createdRoutine.routineNextDate ? this.createdRoutine.routineNextDate : null

                        selectedActivity.isRoutineTemplate = true
                        if (!selectedActivity.generatedActivityId) {
                            selectedActivity.generatedActivityId = selectedActivity.activityId
                        }
                        routineObjects.push(selectedActivity)
                    }
                }
                for (const activity in routineObjects) {
                    await this.updateActivity(routineObjects[activity])
                }
                this.$parent.$parent.$parent.savedTimestamp = new Date()
                this.closeModal()
            }
        },
        getRandomGuid () {
            let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16)
            let guid = [u.substr(0, 8), u.substr(8, 4), '4000-8' + u.substr(13, 3), u.substr(16, 12)].join('-')
            return guid
        },
        changeRepeatTime (selected) {
            this.createdRoutine.routineUnitOfTimeTypeId = selected.sysUnitOfTimeTypeId
            this.humanRoutineUnitOfTimeType = selected.description
        },
        subtractNumber () {
            if (this.createdRoutine.routineInterval !== 1) {
                this.createdRoutine.routineInterval -= 1
            }
        },
        addNumber () {
            this.createdRoutine.routineInterval += 1
        },
        changeDeadlineTime (selected) {
            this.createdRoutine.routineDeadlineUnitTypeId = selected.sysUnitOfTimeTypeId
            this.humanRoutineDeadlineUnitType = selected.description
        },
        subtractDeadlineNumber () {
            if (this.createdRoutine.routineDeadlineInterval !== 1) {
                this.createdRoutine.routineDeadlineInterval -= 1
            }
        },
        addDeadlineNumber () {
            this.createdRoutine.routineDeadlineInterval += 1
        }
    },
    created () {
        if (this.data) {
            this.createdRoutine.routineInterval = this.data.routineInterval
            this.createdRoutine.routineUnitOfTimeTypeId = this.data.routineUnitOfTimeTypeId
            this.humanRoutineUnitOfTimeType = this.unitOfTimeTypeList.filter(unit => unit.sysUnitOfTimeTypeId === this.data.routineUnitOfTimeTypeId)[0].description
            this.createdRoutine.routineDeadlineInterval = this.data.routineDeadlineInterval
            this.createdRoutine.routineDeadlineUnitTypeId = this.data.routineDeadlineUnitTypeId
            this.humanRoutineDeadlineUnitType = this.unitOfTimeTypeList.filter(unit => unit.sysUnitOfTimeTypeId === this.data.routineDeadlineUnitTypeId)[0].description
            this.createdRoutine.routineIntervalTypeId = this.routineIntervalTypeList.filter(unit => unit.sysRoutineIntervalTypeId === this.data.routineIntervalTypeId)[0].sysRoutineIntervalTypeId
            this.createdRoutine.startDate = this.data.startDate
            this.createdRoutine.latestDate = this.data.latestDate
            this.createdRoutine.routineNextDate = this.data.routineNextDate
        } else {
            this.createdRoutine.routineInterval = 1
            this.createdRoutine.routineUnitOfTimeTypeId = this.unitOfTimeTypeList.filter(unit => unit.code === 1)[0].sysUnitOfTimeTypeId
            this.humanRoutineUnitOfTimeType = this.unitOfTimeTypeList.filter(unit => unit.code === 1)[0].description
            this.createdRoutine.routineDeadlineInterval = 1
            this.createdRoutine.routineDeadlineUnitTypeId = this.unitOfTimeTypeList.filter(unit => unit.code === 1)[0].sysUnitOfTimeTypeId
            this.humanRoutineDeadlineUnitType = this.unitOfTimeTypeList.filter(unit => unit.code === 1)[0].description
            this.createdRoutine.routineIntervalTypeId = this.routineIntervalTypeList.filter(unit => unit.code === 1)[0].sysRoutineIntervalTypeId
            this.createdRoutine.startDate = new Date()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/task/task-modal-routine.vue